import { ErrorHandler, Injectable, InjectionToken, inject } from '@angular/core';
import { PreviewContextService } from '../preview-context/preview-context.service';
import { ExceptionTelemetryLocation, reportGlobalException } from './global-exception-telemetry';

export const EXCEPTION_TELEMETRY_LOCATION = new InjectionToken<ExceptionTelemetryLocation>(
  'Exception telemetry location', { providedIn: 'root', factory: () => window.location }
);

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {
  private location = inject(EXCEPTION_TELEMETRY_LOCATION);
  private previewContext = inject(PreviewContextService);

  override handleError(error: unknown): void {
    reportGlobalException(error, 'global_handler', this.location, this.previewContext.isPreviewUser);
  }
}
